import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '../pages/LoginPage';
import { DashboardPage } from '../pages/DashboardPage';
import { EngagementPage } from '../pages/EngagementPage';
// import { UsersPage } from '../pages/UsersPage';
// import { UsersPageWithActions as UsersPage } from '../pages/UsersPageWithActions';
// import { AdminUsersPage as UsersPage } from '../pages/AdminUsersPage';
import { UsersPageEnhanced as UsersPage } from '../pages/UsersPageEnhanced';
import { WalksPage } from '../pages/WalksPage';
import { EventsPage } from '../pages/EventsPage';
// import { SchoolsPage } from '../pages/SchoolsPage';
// import { SchoolsPageWithCampuses as SchoolsPage } from '../pages/SchoolsPageWithCampuses';
import { SchoolsPageImproved as SchoolsPage } from '../pages/SchoolsPageImproved';
import { IdeasPage } from '../pages/IdeasPage';
import { InterestsPage } from '../pages/InterestsPage';
import { InterestGroupsPage } from '../pages/InterestGroupsPage';
import { PlacesPage } from '../pages/PlacesPage';
import { PopularPlacesPage } from '../pages/PopularPlacesPage';
import { PlaceTypesPage } from '../pages/PlaceTypesPage';
import { SurpriseRollsPage } from '../pages/SurpriseRollsPage';
import { ProfilePage } from '../pages/ProfilePage';
import AdminMessageHistoryPage from '../pages/AdminMessageHistoryPage';
import { MessagesPage } from '../pages/MessagesPage';
import AuditLogs from '../pages/AuditLogs';
import UserActivity from '../pages/UserActivity';
import { LockedUsersPage } from '../pages/LockedUsersPage';
import { SpacesPage } from '../pages/SpacesPage';
import { SpaceDetailsPage } from '../pages/SpaceDetailsPage';
import { SpaceFormPage } from '../pages/SpaceFormPage';
import SpaceCategoriesPage from '../pages/SpaceCategoriesPage';
import { RolesManagementPage } from '../pages/RolesManagementPage';
import { ReportsPage } from '../pages/ReportsPage';
import { BannedUsersPage } from '../pages/BannedUsersPage';
import { IncompleteProfilesPage } from '../pages/IncompleteProfilesPage';
import { PossibleGarbagePage } from '../pages/PossibleGarbagePage';
import { AreasOfStudyPage } from '../pages/AreasOfStudyPage';
import { ReportReasonsPage } from '../pages/ReportReasonsPage';
import { DefaultContentSettingsPage } from '../pages/DefaultContentSettingsPage';
import { WalkyAccountsPage } from '../pages/WalkyAccountsPage';
import { WalkyBroadcastPage } from '../pages/WalkyBroadcastPage';
import { DeletionRequestsPage } from '../pages/DeletionRequestsPage';
import { ReactivationRequestsPage } from '../pages/ReactivationRequestsPage';
import JobMonitoringPage from '../pages/JobMonitoringPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: React.createElement(LoginPage),
  },
  {
    path: '/',
    element: React.createElement(ProtectedRoute, null, React.createElement(DashboardPage)),
  },
  {
    path: '/engagement',
    element: React.createElement(ProtectedRoute, null, React.createElement(EngagementPage)),
  },
  {
    path: '/analytics',
    element: React.createElement(Navigate, { to: '/engagement', replace: true }),
  },
  {
    path: '/users',
    element: React.createElement(ProtectedRoute, null, React.createElement(UsersPage)),
  },
  {
    path: '/admin/users',
    element: React.createElement(ProtectedRoute, null, React.createElement(UsersPage)),
  },
  {
    path: '/walks',
    element: React.createElement(ProtectedRoute, null, React.createElement(WalksPage)),
  },
  {
    path: '/events',
    element: React.createElement(ProtectedRoute, null, React.createElement(EventsPage)),
  },
  {
    path: '/schools',
    element: React.createElement(ProtectedRoute, null, React.createElement(SchoolsPage)),
  },
  {
    path: '/places',
    element: React.createElement(ProtectedRoute, null, React.createElement(PlacesPage)),
  },
  {
    path: '/popular-places',
    element: React.createElement(ProtectedRoute, null, React.createElement(PopularPlacesPage)),
  },
  {
    path: '/interests',
    element: React.createElement(ProtectedRoute, null, React.createElement(InterestsPage)),
  },
  {
    path: '/interest-groups',
    element: React.createElement(ProtectedRoute, null, React.createElement(InterestGroupsPage)),
  },
  {
    path: '/place-types',
    element: React.createElement(ProtectedRoute, null, React.createElement(PlaceTypesPage)),
  },
  {
    path: '/surprise-rolls',
    element: React.createElement(ProtectedRoute, null, React.createElement(SurpriseRollsPage)),
  },
  {
    path: '/ideas',
    element: React.createElement(ProtectedRoute, null, React.createElement(IdeasPage)),
  },
  {
    path: '/profile',
    element: React.createElement(ProtectedRoute, null, React.createElement(ProfilePage)),
  },
  {
    path: '/admin/messages',
    element: React.createElement(ProtectedRoute, null, React.createElement(AdminMessageHistoryPage)),
  },
  {
    path: '/messages',
    element: React.createElement(ProtectedRoute, null, React.createElement(MessagesPage)),
  },
  {
    path: '/audit-logs',
    element: React.createElement(ProtectedRoute, null, React.createElement(AuditLogs)),
  },
  {
    path: '/user-activity/:userId',
    element: React.createElement(ProtectedRoute, null, React.createElement(UserActivity)),
  },
  {
    path: '/locked-users',
    element: React.createElement(ProtectedRoute, null, React.createElement(LockedUsersPage)),
  },
  {
    path: '/spaces',
    element: React.createElement(ProtectedRoute, null, React.createElement(SpacesPage)),
  },
  {
    path: '/spaces/new',
    element: React.createElement(ProtectedRoute, null, React.createElement(SpaceFormPage)),
  },
  {
    path: '/spaces/:spaceId',
    element: React.createElement(ProtectedRoute, null, React.createElement(SpaceDetailsPage)),
  },
  {
    path: '/spaces/:spaceId/edit',
    element: React.createElement(ProtectedRoute, null, React.createElement(SpaceFormPage)),
  },
  {
    path: '/space-categories',
    element: React.createElement(ProtectedRoute, null, React.createElement(SpaceCategoriesPage)),
  },
  {
    path: '/roles',
    element: React.createElement(ProtectedRoute, null, React.createElement(RolesManagementPage)),
  },
  {
    path: '/reports',
    element: React.createElement(ProtectedRoute, null, React.createElement(ReportsPage)),
  },
  {
    path: '/banned-users',
    element: React.createElement(ProtectedRoute, null, React.createElement(BannedUsersPage)),
  },
  {
    path: '/incomplete-profiles',
    element: React.createElement(ProtectedRoute, null, React.createElement(IncompleteProfilesPage)),
  },
  {
    path: '/possible-garbage',
    element: React.createElement(ProtectedRoute, null, React.createElement(PossibleGarbagePage)),
  },
  {
    path: '/areas-of-study',
    element: React.createElement(ProtectedRoute, null, React.createElement(AreasOfStudyPage)),
  },
  {
    path: '/report-reasons',
    element: React.createElement(ProtectedRoute, null, React.createElement(ReportReasonsPage)),
  },
  {
    path: '/deletion-requests',
    element: React.createElement(ProtectedRoute, null, React.createElement(DeletionRequestsPage)),
  },
  {
    path: '/reactivation-requests',
    element: React.createElement(ProtectedRoute, null, React.createElement(ReactivationRequestsPage)),
  },
  {
    path: '/walky-accounts',
    element: React.createElement(ProtectedRoute, null, React.createElement(WalkyAccountsPage)),
  },
  {
    path: '/walky-broadcast',
    element: React.createElement(ProtectedRoute, null, React.createElement(WalkyBroadcastPage)),
  },
  {
    path: '/default-content',
    element: React.createElement(ProtectedRoute, null, React.createElement(DefaultContentSettingsPage)),
  },
  {
    path: '/jobs',
    element: React.createElement(ProtectedRoute, null, React.createElement(JobMonitoringPage)),
  },
  {
    path: '*',
    element: React.createElement(Navigate, { to: '/', replace: true }),
  },
]);
